<template>
  <div>
    <img src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/CAC/boothguide.png" :width="'100%'" />
    <div class="boothMap">
      <div class="boothMapList">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="12" :md="12" :lg="12" v-for="(item,index) in list" :key="index">
            <div class="boothMapBox flex fs pointer">
              <div class="boothMapBoxLeft flex fs">
                <div class="boothMapBoxSort">
                  {{ item.sort }}<span class="sort_">{{ item.sort_ }}</span>
                </div>
                <div class="boothMapBoxdesc">
                  <!-- <div>展厅</div> -->
                  <div class="boothMapBoxdescHall">Hall</div>
                </div>
              </div>
              <div class="boothMapBoxThumbnail" style="margin: auto;">
                <el-image class="boothMapBoxThumbnailImg" :fit="'contain'" :src="item.thumbnail"
                  :preview-src-list="item.srcList">
                </el-image>
              </div>
            </div>
          </el-col>
        </el-row>
        <div class="boothMapNavigation pointer" @click="goUrl()" v-if="false">
          <img src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/CAC/navigation.png"
            :width="'100%'" />
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        list: [
          {
            sort: '5',
            sort_: '.2',
            thumbnail: 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/cac/5.2.jpg',
            srcList: ['https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/cac/5.2.jpg']
          },
          {
            sort: '6',
            sort_: '.2',
            thumbnail: 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/cac/6.2.jpg',
            srcList: ['https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/cac/6.2.jpg']
          },
          {
            sort: '7',
            sort_: '.2',
            thumbnail: 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/cac/7.2.jpg',
            srcList: ['https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/cac/7.2.jpg']
          },
          {
            sort: '1',
            sort_: '.2',
            thumbnail: 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/cac/1.2.jpg',
            srcList: ['https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/cac/1.2.jpg']
          },
          {
            sort: '2',
            sort_: '.2',
            thumbnail: 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/cac/2.2.jpg',
            srcList: ['https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/cac/2.2.jpg']
          },
          {
            sort: '8',
            sort_: '.2',
            thumbnail: 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/cac/8.2.jpg',
            srcList: ['https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/cac/8.2.jpg']
          },
        ]
      }
    },
    methods: {
      goUrl() {
        window.open('https://dh.3dqiye.com/demo/index.html', '_blank')
      }
    },
  }
</script>

<style lang="stylus" scoped>
.boothMap{
  width: 100%;
  max-width: 1280px;
  margin: 0px auto;
}
.boothMapList{
  // width: 100%;
  // padding-left: 15px;
  // padding-right: 15px;
  // padding-bottom: 60px;
  // max-width: 1280px;
  // margin: 24px auto 0;
  // overflow: hidden;
  position: absolute;
  max-width: 1280px;
  padding: 15px;
}
.boothMapBox{
  margin:10px 0; 
  border-radius: 8px; 
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.15);
}
.boothMapBoxLeft{
  width:200px;
  height:200px;
  background:#009A6D;
  text-align: center;
  border-radius: 8px 0 0 8px;
}
.boothMapBoxSort{
  height: 135px;
  font-weight: 600;
  font-size: 90px;
  color: #FFFFFF;
  line-height: 135px;
  margin:45px 10px 20px 15px;
}
.sort_{
  font-size: 45px;
}
.boothMapBoxdesc{
  margin-top:108px;
  height: 32px;
  font-weight: 400;
  font-size: 32px;
  color: #FFFFFF;
  line-height: 32px;
}
.boothMapBoxdescHall{
  margin-top:10px;  
}
.boothMapNavigation{
  width:80px;
  height:80px;
  position: absolute;
  top: 25px;
  right: -110px;
  bottom: auto;
}
.boothMapBoxThumbnailImg{
  width: 375px;
  height: 194px;
}

@media screen and (max-width: 767px) {
  .boothMap{
    width: 100%;
    max-width: 1280px;
    margin: 0px auto;
  }
  .boothMapBoxLeft{
    min-width:120px;
    max-height:120px;
    background:#009A6D;
    text-align: center;
    border-radius: 8px 0 0 8px;
  }
  .boothMapBoxSort{
    height: 100px;
    font-weight: 600;
    font-size: 60px;
    color: #FFFFFF;
    line-height: 100px;
    margin:20px 10px 10px 8px;
  }
  .sort_{
    font-size: 30px;
  }
  .boothMapBoxdesc{
    margin-top:73px;
    height: 20px;
    font-weight: 400;
    font-size: 20px;
    color: #FFFFFF;
    line-height: 26px;
  }
  .boothMapBoxdescHall{
    margin-top:0px;  
  }
  .boothMapBoxThumbnail{
    max-height:150px;
    img{
      width:100%;
      height:100%;
    }
  }
  .boothMapNavigation{
    width:80px;
    height:80px;
    position: fixed;
    right: 15px;
    bottom: 15px;
    top: auto;
    z-index:10;
  }
  .boothMapBoxThumbnailImg{
    width: 180px;
    height: 110px;
  }
}
</style>